<template>
<div>
  <el-table :data="recordList">
    <el-table-column prop="userId" label="用户ID">
    </el-table-column>
    <el-table-column prop="amount" label="数量">
      <template slot-scope="scope">
        <span>{{scope.row.amount}} {{scope.row.currency}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="status  " label="状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__status.color">
          {{scope.row.__status.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="时间">
      <template slot-scope="scope">
        <span>{{scope.row.createdTime | moment}}</span>
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange">
  </pagination>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'foundationRecordList',
  computed: {
    ...mapState('foundationRecord', ['totalCount', 'pagination']),
    ...mapGetters('foundationRecord', ['recordList'])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
</style>
